// extracted by mini-css-extract-plugin
module.exports = {"container":"previewEmail_container__kHGwA","overlay":"previewEmail_overlay__2QPyz","icon":"previewEmail_icon__2za3p","crossContainer":"previewEmail_crossContainer__o4_7A"};